import { render, staticRenderFns } from "./QualificationTable.vue?vue&type=template&id=5db0b2ba"
import script from "./QualificationTable.vue?vue&type=script&lang=ts"
export * from "./QualificationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports